import { supabase } from '@/integrations/supabase/client';

import { createCRUDEntity } from '../crud-factory';
import { transformImageSEOData, transformFilterKeys } from '../transformations';

// ImageSEOMetadata Entity with custom helper methods
export const ImageSEOMetadata = createCRUDEntity('image_seo_metadata', transformImageSEOData, {
  customMethods: {
    // Override filter to handle field transformations
    filter: async (filters: Record<string, unknown>, orderBy = '-created_at') => {
      const orderField = orderBy.startsWith('-') ? orderBy.slice(1) : orderBy;

      let query = supabase.from('image_seo_metadata').select('*');

      // Apply filters with field mapping
      const fieldMap = {
        image_id: null, // Remove this field
        title: 'title_text', // Map to new field name
      };

      const transformedFilters = transformFilterKeys(filters, fieldMap);
      for (const [key, value] of Object.entries(transformedFilters)) {
        query = query.eq(key, value as string | number | boolean);
      }

      const { data, error } = await query.order(orderField, {
        ascending: orderBy.startsWith('-') ? false : true,
      });
      if (error) throw error;
      return data;
    },

    // Helper method to find metadata by image URL (primary identifier)
    getByImageUrl: async (imageUrl: string) => {
      const { data, error } = await supabase
        .from('image_seo_metadata')
        .select('*')
        .eq('image_url', imageUrl)
        .single();
      if (error && error.code !== 'PGRST116') throw error; // PGRST116 is "not found" error
      return data;
    },

    // Helper method to find metadata by entity
    getByEntity: async (entityType: string, entityId: string) => {
      const { data, error } = await supabase
        .from('image_seo_metadata')
        .select('*')
        .eq('entity_type', entityType)
        .eq('entity_id', entityId);
      if (error) throw error;
      return data;
    },
  },
});
